import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61ca2b72&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ca2b72')) {
      api.createRecord('61ca2b72', component.options)
    } else {
      api.reload('61ca2b72', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=61ca2b72&", function () {
      api.rerender('61ca2b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/dashboard/screens/DashboardScreen/index.vue"
export default component.exports